import { Injectable } from '@angular/core';
import { ImportedDatasetFacade } from '@mode/switch-views/contract';
import { Action, Store } from '@ngrx/store';
import { DomainAppState } from '../switch-view-domain.types';

@Injectable()
export class ImportedDatasetService extends ImportedDatasetFacade {
  constructor(private store: Store<DomainAppState>) {
    super();
  }

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
